import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/main/Auth.css";
import ToastPopup from "../Popups/ToastPopup";
import { LoginProps, createToastMessage, ToastMessage } from "../Interfaces/Interface";
import { apiCall } from "./Apicall";
const Login: React.FC<LoginProps> = ({ setToken }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("email", email);
      params.append("password", password);
      const response = await apiCall("post", "/api/auth/login", params, undefined,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );
      const { token, sessionKey } = response;
      if (typeof token === "string" && token.startsWith("ey")) {
        localStorage.setItem("accessToken", token);
        localStorage.setItem("sessionKey", sessionKey);
        setToken(token);
        setMessage(createToastMessage("Authentication Successful", "success", 3000));
        setTimeout(() => { navigate("/client") }, 500);
      } else {
        setMessage(createToastMessage("Login failed. Please try again.", "error", 3000));
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Invalid Email or Password";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="login-container">
      <div className="login-left">
        <img src="/audit.png" alt="Audit Illustration" className="audit-illustration" />
      </div>
      <div className="login-right">
        <div className="login-box">
          <h2>Welcome to Auditzen Management!!! 👋</h2>
          <p>Sign in to your account and start the adventure</p>
          <form onSubmit={handleLogin}>
            <input type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} className="login-input" required />
            <input type="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} className="login-input" required />
            <button type="submit" className={`login-button ${isLoading ? "loading" : ""}`} disabled={isLoading}>{isLoading ? "Logging in..." : "Login"}</button>
          </form>
        </div>
      </div>
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default Login;